import type { CSSProperties } from 'react';
import { useEffect, useState } from 'react';
import TwgLogo from '#assets/twg_logo.png';
import { useToken } from '../../../../Flow/ConsentContextProvider';

const TWG_LOGO_URL = TwgLogo;

const styles: Record<string, CSSProperties> = {
  image: {
    backgroundColor: '#ffffff',
    border: '1px solid rgba(9, 30, 66, 0.14)',
    borderRadius: '10px',
    boxShadow: '0 2px 8px rgba(9, 30, 66, 0.18)',
    boxSizing: 'border-box',
    height: '48px',
    objectFit: 'contain',
    padding: '8px',
    width: '48px',
  },
};

const Logo = () => {
  const { clientLogoUrl, clientName } = useToken();
  const [logoSrc, setLogoSrc] = useState(clientLogoUrl || TWG_LOGO_URL);

  useEffect(() => {
    setLogoSrc(clientLogoUrl || TWG_LOGO_URL);
  }, [clientLogoUrl]);

  return (
    <img
      src={logoSrc}
      alt={clientName ?? undefined}
      onError={() => {
        if (logoSrc !== TWG_LOGO_URL) {
          setLogoSrc(TWG_LOGO_URL);
        }
      }}
      style={styles.image}
    />
  );
};

export default Logo;
